'use strict';
// @flow

import ModalPoliticaSenha from './modal_politica_senha';

export default ModalPoliticaSenha;